import { render, staticRenderFns } from "./OpenDocumentSideDrawer.vue?vue&type=template&id=151b5f9f&scoped=true"
import script from "./OpenDocumentSideDrawer.vue?vue&type=script&lang=ts"
export * from "./OpenDocumentSideDrawer.vue?vue&type=script&lang=ts"
import style0 from "./OpenDocumentSideDrawer.vue?vue&type=style&index=0&id=151b5f9f&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151b5f9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('151b5f9f')) {
      api.createRecord('151b5f9f', component.options)
    } else {
      api.reload('151b5f9f', component.options)
    }
    module.hot.accept("./OpenDocumentSideDrawer.vue?vue&type=template&id=151b5f9f&scoped=true", function () {
      api.rerender('151b5f9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/PackageDocument/Components/OpenDocumentSideDrawer.vue"
export default component.exports